import { styled } from '../theme-provider';

export const ExpiredTokenLayout = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
`;
